import * as React from 'react'
import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, TextField, Typography } from '@mui/material'
import { dialogTypographyStyle, rowHeight } from '../Graphics'
import { getMemberShapeData } from '../data/MemberShapeData'

type Props = {
  shapeName: string
  handleChange: ((event: React.SyntheticEvent<Element, Event>, value: string | null, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<string> | undefined) => void) | undefined
  customShape?: boolean
  memberClassFilter?: string
  label?: string
}

export default function UISelectShapeName( {shapeName, handleChange, customShape = false, memberClassFilter = '', label = ''}: Props ) {

  const disabled = customShape
  const shapeNames = Array.from(getMemberShapeData(memberClassFilter)).map(x=>x.name)
  let initShapeName = shapeName
  if(initShapeName === ''){
    initShapeName = shapeNames[0]
  }
  if(customShape){
    initShapeName = ''
  }

  return (
    <>
      {label.length > 0 ? <Typography sx={dialogTypographyStyle} color='secondary'>{label}</Typography> : <></>}
      <Autocomplete disabled={disabled}
        freeSolo
        value={initShapeName}
        id="combo-box-shapes"
        options={shapeNames}
        fullWidth
        disableClearable
        size='small'
        sx={{height: rowHeight}}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} />}
      />
    </>  
  )

}